// Module
var code = "<div class=\"c-datatable-drillableCell u-sizeFullWidth ui-grid-cell-contents\">\n    <div smart-truncate ng-bind=\"row.entity.RedemptionCode\" ui-sref=\"index.customercare.customer.coupons.details({ couponRedemptionCodeId: row.entity.RedemptionCodeId})\"></div>\n</div>\n";
// Exports
module.exports = code;